// ─── Nom d'utilisateur (Core) ──────────────────────────────────────
// `users/{uid}.prenom` sert de nom affiché partout dans la suite. Ce module
// ajoute une contrainte d'UNICITÉ, vérifiée via `profilsPublics` (seule
// collection lisible par requête pour tout compte connecté — cf. règles
// Firestore, `users/{uid}` reste privé au propriétaire). Vérification
// best-effort (pas de transaction serveur) : suffisant pour une suite
// familiale, pas garanti sous écriture concurrente sur la même valeur.
import { collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { db } from '../firebase';

const MIN = 2;
const MAX = 30;

// Renvoie un CODE d'erreur (pas un message : à traduire côté écran), ou null si OK.
export function validerNomUtilisateur(nom) {
  const v = (nom || '').trim();
  if (v.length < MIN) return 'court';
  if (v.length > MAX) return 'long';
  return null;
}

export async function nomUtilisateurDisponible(nom, uidActuel) {
  const q = query(collection(db, 'profilsPublics'), where('prenom', '==', nom));
  const snap = await getDocs(q);
  return snap.docs.every(d => d.id === uidActuel);
}

// Lève une erreur avec `.code` ('court' | 'long' | 'pris') si invalide.
export async function changerNomUtilisateur(uid, nouveauNom) {
  const nom = (nouveauNom || '').trim();
  const err = validerNomUtilisateur(nom);
  if (err) throw Object.assign(new Error(err), { code: err });
  if (!(await nomUtilisateurDisponible(nom, uid))) {
    throw Object.assign(new Error('pris'), { code: 'pris' });
  }
  await updateDoc(doc(db, 'users', uid), { prenom: nom });
}
